import styled from '@emotion/styled';

const Tag = styled.div(({ theme: { primaryColor, secondaryColor } }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  textAlign: 'center',
  minHeight: 24,
  boxSizing: 'border-box',
  padding: '4px 16px',
  margin: '0 8px 8px 0',
  backgroundColor: secondaryColor,
  borderRadius: 8,
  color: primaryColor,
  lineHeight: '16px',
  fontSize: 12,
  strong: {
    fontWeight: 800,
    letterSpacing: '-0.5px',
    marginLeft: '3px',
  }
}));

export default Tag;
